import React from "react";
import { Icon, support } from "Icons/index";

import t from "Utils/translation";
import cx from "classnames";
import s from "./supportContactBox.scss";

class SupportContactBox extends React.Component {
  render() {
    const { className } = this.props;

    return (
      <div className={cx(className, s.box)}>
        <Icon className={s.icon} svg={support} width="3.5rem" height="3.5rem" />
        <div className={s.question}>{t("supportContactBox.question")}</div>
        <div className={s.cta}>{t("supportContactBox.cta")}</div>

        <a className={s.phone} href="tel:+390574026030">
          +39 0574 026030
        </a>
        <div className={s.schedule}>{t("supportContactBox.schedule")}</div>
      </div>
    );
  }
}

export default SupportContactBox;
